import type { IAttributes, IVariable } from '@src/interfaces'

const buildAttributes = (root: string, attributes: any, lang: string): IAttributes[] => {
  return attributes.map(({ key, name, type = '' }: { key: string; name: string; type: string }) => {
    const value =
      type === 'Array'
        ? `{% for ${key.substr(0, 3)} in ${root}.${key} %} {% endfor %}`
        : `{{ ${root}.${key} }}`

    return {
      name: typeof name === 'string' ? name : name[lang],
      value
    }
  })
}

const setLabel = (
  type: 'object' | 'array',
  root: string,
  collection: string
): string | undefined => {
  return type === 'array' ? `{% for ${root} in ${collection} %}-{% endfor %} ` : undefined
}

export const variablesParser = (variables: any, lang: string = 'es'): IVariable[] => {
  const parsedVariables: IVariable[] = []

  variables.forEach((current: any, i: number) => {
    const { visible, type, name, root, attributes, collection = null } = current
    if (!visible) return

    parsedVariables.push({
      id: i,
      name: name[lang] || name['es'],
      label: setLabel(type, root, collection),
      attributes: buildAttributes(root, attributes, name[lang] ? lang : 'es')
    })
  })

  return parsedVariables
}
